<template>
  <div id="member-prop-editor">

    <ErrorPopup
      :error="error"
    />

    <memlist-modal ref="edit-prop" size="lg" :ok-title="$t('COMMON.SAVE')">
    
      <form class="mt-8">
        <memlist-text-input
          id="input-prop_id"
          v-model="local_item.prop_id"
          :title="'ID'"
          layout="vertical"
          type="text"
          disabled
        />

        <memlist-text-input
          class="mt-4"
          id="input-prop-name"
          v-model="local_item.name"
          :title="$t('ATTRIBUTE.NAME')"
          layout="vertical"
          type="text"
        />

        <memlist-textarea
          class="mt-4"
          id="input-prop-descr"
          v-model="local_item.descr"
          :title="$t('ATTRIBUTE.DESCR')"
          layout="vertical"
          type="textarea"
          size="sm"
          :placeholder="$t('ATTRIBUTE.DESCR_PLACEHOLDER')"
        />

        <memlist-checkbox
          class="mt-4"
          v-model="local_item.is_free_text"
          :title="$t('ATTRIBUTE.IS_FREE_TEXT')"
        />

        <RightModalSaveAndCloseButtons
          class="mt-4"
          :text="$t('COMMON.SAVE')"
          :spin="true"
          @click="submit_form"
          @close="on_cancel"
          ref="saveButton"
        />

      </form>

    </memlist-modal>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';

export default {
  name: 'MemberPropertyEditorModal',
  components: {
    
    RightModalSaveAndCloseButtons
  },
  mixins: [ toasts ],
  
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'pages', 'isTHS']),
    
  },
  props: ['prop_id','group_id'],
  emits: ['created', 'updated'],
  async mounted() {
    
  },
  watch: {
    
    async prop_id(new_val, old_val) {
      console.log('prop_id changed', new_val)
      if (new_val) {
        this.local_item = await this.get_prop(new_val);
      }
      else {
        this.local_item = {};
      }
    },
  },
  methods: {
    on_cancel() {
      this.$refs['edit-prop'].hide();
    },
    
    async get_prop(prop_id) {
      const res = await axios.get(`/member_property/${prop_id}`);

      return res.data;
    },
    async put_prop(form) {
      try {
        
        const res = await axios.put(`/member_property/${form.prop_id}`, form)

        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('ATTRIBUTE.UPDATED'));
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ATTRIBUTE.UNABLE_UPDATE'));
        }
      }
      catch (err) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ATTRIBUTE.UNABLE_UPDATE'));
      }

    },

    async post_prop(form) {
      try {

        form.group_id = this.group_id;
        form.company_id = this.currentCompanyId;

        const res = await axios.post('/member_property', form);

        if (res.status === 201) {
          
          this.toastr('success', this.$t('COMMON.OK'), this.$t('ATTRIBUTE.CREATED'));
          return res.data;
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ATTRIBUTE.UNABLE_CREATE'));
        }
      }
      catch (err) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ATTRIBUTE.UNABLE_UPDATE'));
      }

      return null;

    },

    async submit_form() {
      

      try {
        if (this.local_item.prop_id) {
          await this.put_prop(this.local_item);
          this.$emit('updated', this.local_item);
        }
        else {
          const data = await this.post_prop(this.local_item);
          this.local_item = data;

          this.$emit('created', this.local_item);
        }

        this.$refs['saveButton'].stop();
      }
      catch (err) {
        console.error('submit_form error', err);
        this.$refs['saveButton'].stop();
      }

    },

    show() {
      this.$refs['edit-prop'].show();

      this.$nextTick(()=>{
        if (this.local_user_id) {
          this.get_user(this.local_user_id);
        }
      });
    },

    reset() {
      this.local_item = {};
    },

  },
  data() {
    return {
      error: null,
      local_item: {}
    };
  },
  

};
</script>
